import styled from '@emotion/styled';

import COLOR from '../../../../../shared/constant/colorset';

const Title = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 34px;
`;

const TextLine = styled.div`
  width: 180px;
  height: 32px;
  margin-top: 8px;
  background-color: ${COLOR.kurlyGray200};
  &:first-of-type {
    margin-top: 0;
  }
`;

export default function SectionHeaderSkeleton() {
  return (
    <Title>
      <TextLine/>
    </Title>
  );
}
